import { Controller } from "@hotwired/stimulus"

// Restricts input to Uruguayan phone format: 09 + 7 digits (9 chars total).
// Only allows digits; auto-prefixes "0" if user starts with "9".
export default class extends Controller {
  static values = { maxLength: { type: Number, default: 9 } }

  connect() {
    this.boundFormat = this.format.bind(this)
    this.boundPaste = () => setTimeout(this.boundFormat, 0)
    this.element.addEventListener("input", this.boundFormat)
    this.element.addEventListener("paste", this.boundPaste)
  }

  disconnect() {
    this.element.removeEventListener("input", this.boundFormat)
    this.element.removeEventListener("paste", this.boundPaste)
  }

  format() {
    let digits = this.element.value.replace(/\D/g, "").slice(0, this.maxLengthValue)
    if (digits.length > 0 && digits[0] === "9") {
      digits = ("0" + digits).slice(0, this.maxLengthValue)
    }
    this.element.value = digits

    // Custom validation message in Spanish for pattern mismatch
    if (this.element.validity.patternMismatch) {
      this.element.setCustomValidity("Debe ser un teléfono uruguayo válido (09 seguido de 7 dígitos)")
    } else {
      this.element.setCustomValidity("")
    }
  }
}
